$('.js-collapsed__btn').on('click', function(e) {
    e.preventDefault();
    const $btn = $(this);
    const $wrapper = $btn.closest('.js-collapsed').find('.js-collapsed__wrapper');
    const $content = $wrapper.find('.js-collapsed__content');

    $wrapper
        .velocity({
            maxHeight: $content.outerHeight()
        }, {
            duration: 1500,
            complete: function() {
                $wrapper.addClass('collapsed__wrapper--full-height')
                $btn.hide()
            }
        })
})


// WEBPACK FOOTER //
// ./frontend/components/collapsed/collapsed.js